import React from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  currentSong?: any | null;
};

const CastOptionsModal: React.FC<Props> = ({ isOpen, onClose, currentSong }) => {
  if (!isOpen) return null;

  const isYouTube = currentSong && (currentSong.source === 'youtube' || currentSong.platform === 'youtube');
  const videoId: string | undefined = currentSong?.videoId || currentSong?.youtubeId || currentSong?.id;
  const youTubeUrl = videoId ? `https://www.youtube.com/watch?v=${videoId}` : undefined;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-md rounded-lg bg-gray-900 text-white shadow-xl border border-white/10">
        <div className="px-5 py-4 border-b border-white/10 flex items-center justify-between">
          <h3 className="text-lg font-semibold">Cast to TV</h3>
          <button className="text-gray-300 hover:text-white" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div className="px-5 py-4 space-y-4 text-sm">
          <p className="text-gray-300">
            For the lowest delay, a wired HDMI connection is best. If you prefer casting, try one of these options:
          </p>
          {isYouTube && youTubeUrl ? (
            <div className="space-y-2">
              <a
                href={youTubeUrl}
                target="_blank"
                rel="noreferrer"
                className="block w-full text-center px-4 py-2 bg-red-600 hover:bg-red-500 rounded font-semibold"
              >
                Open current song in YouTube app
              </a>
              <p className="text-gray-400">
                Then tap the Cast icon in the YouTube app to send it to your Chromecast or Cast-enabled TV.
              </p>
            </div>
          ) : (
            <div className="space-y-2">
              <div className="px-3 py-2 bg-gray-800/60 rounded border border-white/10">
                <div className="font-medium mb-1">Casting support for CD+G/local tracks</div>
                <p className="text-gray-400">
                  CD+G lyric rendering runs on this device (canvas). To cast those tracks, use a wired HDMI adapter
                  or run the Display window on a laptop connected to the TV. Full Chromecast support for CD+G is on
                  our roadmap.
                </p>
              </div>
            </div>
          )}
          <div className="pt-2 text-gray-400">
            Tip: Enable your TV's Game Mode to reduce display processing delay.
          </div>
        </div>
        <div className="px-5 py-4 border-t border-white/10 flex justify-end">
          <button className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default CastOptionsModal;
